import {
  GET_ALL_DISTRICT,
  GET_DISTRICT_TO,
  GET_DISTRICT_FROM,
  SET_LOADED_DISTRICT_BY_CITY_CODE,
  GET_DISTRICT_KIND,
  SET_LOADED_DISTRICT_BY_CITY_ID,
  GET_DISTRICT
} from 'src/store/mutation-types'
export default {
  [GET_ALL_DISTRICT] (state, districts) {
    state.districts = districts
  },
  [GET_DISTRICT_TO] (state, districts) {
    state.districtTo = districts
  },
  [GET_DISTRICT_FROM] (state, districts) {
    state.districtFrom = districts
  },
  [SET_LOADED_DISTRICT_BY_CITY_CODE] (state, params) {
    state.districtsByCityCode[params.city_code] = params.districts
  },
  [GET_DISTRICT_KIND] (state, districts) {
    state.districtKind = districts
  },
  [SET_LOADED_DISTRICT_BY_CITY_ID] (state, params) {
    state.districtsByCityId[params.city_id] = params.districts
  },
  [GET_DISTRICT] (state, district) {
    state.district = district
  }
}



// WEBPACK FOOTER //
// ./src/components/district/store/mutations.js